const { Cycler } = window.BAO

class CollectionSwitch extends window.BAO.CustomElement() {
  CURRENT_STYLE_ATTRIBUTE = 'current-style'
  ALLOWED_STYLES = ['default', 'lifestyle']
  CLASSES = {
    default: 'clc-ProductGrid-default',
    lifestyle: 'clc-ProductGrid-lifestyle',
  }

  connectedCallback () {
    if (!this.els.trigger.element) {
      throw new Error(
        `<${this.localName}> needs an element with data-collection-switch-el=trigger to work"`,
      )
    }

    this.handleTriggerClick = this.handleTriggerClick.bind(this)
    this.cycler = new Cycler(this.ALLOWED_STYLES)
    this.cycler.set(
      this.cycler.items.findIndex((i) => i === this.currentStyle),
    )

    this.els.trigger.element.addEventListener(
      'click',
      this.handleTriggerClick,
      {
        passive: true,
      },
    )
  }

  disconnectedCallback () {
    this.els.trigger.element.removeEventListener(
      'click',
      this.handleTriggerClick,
    )
  }

  async handleTriggerClick () {
    const currentStyle = this.cycler.next()

    this.setCartAttribute(currentStyle)
    this.currentStyle = currentStyle
    this.syncThemeSwitchers(currentStyle)

    window.BAO.eventBus.dispatchEvent(window.BAO.EVENTS.THEME_SWITCH, {
      currentStyle,
    })
  }

  syncThemeSwitchers (currentStyle) {
    this.allOtherThemeSwitches.forEach((el) => {
      el.currentStyle = currentStyle
      el.cycler.next()
    })
  }

  setCartAttribute (style) {
    // eslint-disable-next-line compat/compat
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        attributes: {
          current_style: style,
        },
      }),
    })
  }

  get currentStyle () {
    return (
      this.getAttribute(this.CURRENT_STYLE_ATTRIBUTE) || this.ALLOWED_STYLES[0]
    )
  }

  set currentStyle (value) {
    this.setAttribute(this.CURRENT_STYLE_ATTRIBUTE, value)

    this.externalEls.body.element.classList.toggle(
      this.CLASSES.default,
      value === 'default',
    )
    this.externalEls.body.element.classList.toggle(
      this.CLASSES.lifestyle,
      value === 'lifestyle',
    )
  }

  get allOtherThemeSwitches () {
    // eslint-disable-next-line compat/compat
    return Array.from(document.querySelectorAll(this.localName)).filter(
      (el) => el !== this,
    )
  }
}

if (!customElements.get('collection-switch')) {
  customElements.define('collection-switch', CollectionSwitch)
}
